"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.new.title': '添加新知识',
    'shortcuts.new.description': '创建或添加新知识到系统中',
};
